import { dateFormatOnCulture } from './dateFormatOnCulture'
import day from 'dayjs'

function formatDate (value, format) {
  let formatStr = ''
  switch (format) {
    case 'date':
      formatStr = day(value).format(dateFormatOnCulture())
      break
    case 'time':
      formatStr = dateFormatOnCulture('time')
      break
    case 'datetime':
      formatStr = dateFormatOnCulture('dateAndTime', value)
      break
    default:
      formatStr = format
      break
  }
  return formatStr
}

function formatDateWithDefault (valueOrEmpty, format, defaultStr) {
  if (valueOrEmpty) {
    return formatDate(valueOrEmpty, format)
  }
  return defaultStr
}

export {
  formatDate,
  formatDateWithDefault
}
